import { Skeleton } from '@systemeio/components'

const NotificationsListSkeleton = () => (
  <>
    <Skeleton className="h-16 rounded-md" />
    <Skeleton className="h-16 rounded-md" />
    <Skeleton className="h-16 rounded-md" />
  </>
)

export default NotificationsListSkeleton
